/* ExpandSectionButton.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["isEmcee"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/new';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import { useSource } from '@atlassian/mpac-utils';
import React, { useContext, useEffect, useState } from 'react';
import { CustomerPrivacySecurityContext } from '../../context/CustomerPrivacySecurityContext';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._1wybljao{font-size:var(--ds-font-size-200,1rem)}";
const _2 = "._1wyb1dph{font-size:var(--ds-font-size-100,.875rem)}";
const _ = "._k48p1pd9{font-weight:var(--ds-font-weight-semibold,600)}";
const ExpandSectionsButtonText = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      isEmcee
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48p1pd9", __cmplp.isEmcee ? "_1wyb1dph" : "_1wybljao", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ExpandSectionsButtonText.displayName = 'ExpandSectionsButtonText';
}
export const ExpandSectionButton = _ref2 => {
  let {
    totalCount,
    text,
    maxCount,
    onChange
  } = _ref2;
  const {
    fireExpandSectionEvent
  } = usePrivacyAndSecurityAnalytics();
  const hasMorePointsThanLimit = totalCount > maxCount;
  const [showExpandButton, setShowExpandButton] = useState(hasMorePointsThanLimit);
  const {
    areAllSectionsExpanded
  } = useContext(CustomerPrivacySecurityContext);
  const source = useSource();
  const handleClick = () => {
    onChange(showExpandButton, true);
    setShowExpandButton(false);
    fireExpandSectionEvent(text);
  };
  useEffect(() => {
    const showButton = areAllSectionsExpanded ? false : hasMorePointsThanLimit;
    setShowExpandButton(showButton);
    onChange(!showButton, false);
  }, [areAllSectionsExpanded]);
  return showExpandButton ? /*#__PURE__*/_jsx(Button, {
    onClick: handleClick,
    iconAfter: ChevronDownIcon,
    children: /*#__PURE__*/_jsx(ExpandSectionsButtonText, {
      isEmcee: source === 'PRODUCT',
      children: text
    })
  }) : null;
};